"use client";

import Cookie from "js-cookie";
import { RequestCookie } from "next/dist/compiled/@edge-runtime/cookies";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
type CookieState = readonly [{
  [key: string]: string;
}, (key: string, value: string) => void, (key: string) => void];
const CookieContext = createContext<CookieState | undefined>(undefined);
export function useCookieState() {
  const ctx = useContext(CookieContext);
  if (!ctx) {
    throw new Error("useCookieState must be used in a CookieManager tree");
  }
  return ctx;
}
export function CookieProvider({
  children,
  initialCookies
}: {
  children: React.ReactNode;
  initialCookies?: [string, RequestCookie][];
}) {
  const [cookies, setStoredCookie] = useState<{
    [key: string]: string;
  }>(initialCookies?.reduce((acc, [_, {
    name: cookieName,
    value
  }]) => {
    acc[cookieName] = value;
    return acc;
  }, {} as {
    [key: string]: string;
  }) ?? {});
  useEffect(() => {
    const cookies_0 = Cookie.get();
    setStoredCookie(cookies_0);
  }, []);
  const setCookie = useCallback((key: string, value_0: string) => {
    Cookie.set(key, value_0, {
      expires: 365,
      secure: true
    });
    setStoredCookie(prev => ({
      ...prev,
      [key]: value_0
    }));
  }, []);
  const removeCookie = useCallback((key_0: string) => {
    Cookie.remove(key_0);
    setStoredCookie(prev_0 => {
      const {
        [key_0]: _,
        ...rest
      } = prev_0;
      return rest;
    });
  }, []);
  const value_1 = useMemo(() => [cookies, setCookie, removeCookie] as const, [cookies, setCookie, removeCookie]);
  return <CookieContext.Provider value={value_1}>{children}</CookieContext.Provider>;
}